import { Image } from "@";

// Columns configuration for the "Our Partners" table
const tableColumns = [
  {
    name: "",
    cell: ({ imageFullUrl }) => <Image size={96} src={imageFullUrl} />,
  },
  {
    name: "العنوان",
    selector: ({ title }) => title,
    grow: 2,
  },
  {
    name: "الرابط",
    selector: ({ link }) => link,
  },
];

export default tableColumns;
